import { render, staticRenderFns } from "./MobileResultsList.vue?vue&type=template&id=19e34e7c&scoped=true&"
import script from "./MobileResultsList.vue?vue&type=script&lang=js&"
export * from "./MobileResultsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e34e7c",
  null
  
)

export default component.exports